module.exports = __webpack_public_path__ + "static/media/fancy_1_universal.bc22c79c.svg";